import { ProjectTypeDto } from '@cradua/data';
import { createAction, props } from '@ngrx/store';

/**
 * Load Countries Collection Actions
 */
export const loadProjectType = createAction('[ProjectType] Load ProjectType');

export const loadProjectTypeSuccess = createAction(
  '[ProjectType] Load ProjectType Success',
  props<{ projectType: ProjectTypeDto[] }>()
);

export const loadProjectTypeFailure = createAction(
  '[ProjectType] Load ProjectType Failure',
  props<{ error: any }>()
);

/**
 * Add Countries to Collection Actions
 */
export const addProjectType = createAction(
  '[ProjectType] Add ProjectType',
  props<{ newProjectType: ProjectTypeDto[] }>()
);

export const addProjectTypeSuccess = createAction(
  '[ProjectType] Add ProjectType Success',
  props<{ newProjectType: ProjectTypeDto[] }>()
);

export const addProjectTypeFailure = createAction(
  '[ProjectType] Add ProjectType Failure',
  props<{ error: any }>()
);

/**
 * Update ProjectType Collection Actions
 */
export const updateProjectType = createAction(
  '[ProjectType] Update ProjectType',
  props<{ updateProjectType: ProjectTypeDto[] }>()
);

export const updateProjectTypeSuccess = createAction(
  '[ProjectType] Update ProjectType Success',
  props<{ updateProjectType: ProjectTypeDto[] }>()
);

export const updateProjectTypeFailure = createAction(
  '[ProjectType] Update ProjectType Failure',
  props<{ error: any }>()
);

/**
 * Remove ProjectType Collection Actions
 */
export const removeProjectType = createAction(
  '[ProjectType] Remove ProjectType',
  props<{ ids: string[] }>()
);

export const removeProjectTypeSuccess = createAction(
  '[ProjectType] Remove ProjectType Success',
  props<{ ids: string[] }>()
);

export const removeProjectTypeFailure = createAction(
  '[ProjectType] Remove ProjectType Failure',
  props<{ error: any }>()
);
